// extracted by extract-css-chunks-webpack-plugin
module.exports = {"AVATAR_SIZE":"80px","authorImageContainer":"_7970Dz","image":"_2gVJi0","imageWrapper":"fyixha"};